module.exports = __webpack_public_path__ + "static/media/animal-daramgi.4cda452d.PNG";